<template>
  <v-dialog v-model="statisticUserCardDialog" width="1200">
    <v-card color="grey lighten-3">
      <!--Country and closebar-->
      <v-toolbar flat color="grey lighten-3">
        <v-spacer></v-spacer>
        <p class="pl-8 text--primary display-1 pt-5">
          More Info
        </p>
        <v-spacer></v-spacer>
        <v-btn color="error" :title="$t('close window')" class="ma-2" outlined icon large @click="closeDialog">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-row class="ma-0 pa-0">
          <!--Total Users-->
          <!-- <v-col md="6">
            <v-hover>
              <v-card outlined height="100%" elevation="6" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 0}`" class="ma-0 pa-0" color="blue lighten-3">
                <v-card-text class="ma-0 pa-0 pa-2">
                  <p class="title text-center">
                    <span>Total Users</span>
                    <span class="display-1 font-weight-bold pl-1">({{item.totalUsers}})</span>
                  </p>
                  <v-divider></v-divider>
                  <v-divider></v-divider>
                  <template v-for="totalUserCountry in sortUsers">
                    <p :Key="totalUserCountry.id" class="title">
                      <span>{{totalUserCountry.country}}:</span>
                      <span class="display-1 font-weight-bold pl-1">{{totalUserCountry.users}}</span>
                    </p>
                  </template>
                </v-card-text>
              </v-card>
            </v-hover>
          </v-col> -->
          <!--New users last 24h-->
          <!-- <v-col md="6">
            <v-hover>
              <v-card outlined height="100%" elevation="6" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 0}`" class="ma-0 pa-0" color="green lighten-3">
                <v-card-text class="ma-0 pa-0 pa-2">
                  <p class="title text-center">
                    <span>Total new users last 24h</span>
                    <span class="display-1 font-weight-bold pl-1">({{item.totalNewUsersDay}})</span>
                  </p>
                  <v-divider></v-divider>
                  <v-divider></v-divider>
                  <template v-for="totalNewUserCountry in sortNewUsers">
                    <p :Key="totalNewUserCountry.id" class="title">
                      <span>{{totalNewUserCountry.country}}:</span>
                      <span class="display-1 font-weight-bold pl-1">{{totalNewUserCountry.newUsers}}</span>
                    </p>
                  </template>
                </v-card-text>
              </v-card>
            </v-hover>
          </v-col> -->
          <!--Active users last 24h-->
          <!-- <v-col md="6">
            <v-hover>
              <v-card outlined height="100%" elevation="6" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 0}`" class="ma-0 pa-0" color="yellow lighten-3">
                <v-card-text class="ma-0 pa-0 pa-2">
                  <p class="title text-center">
                    <span>Total active users last 24h</span>
                    <span class="display-1 font-weight-bold pl-1">({{item.totalActiveUsersDay}})</span>
                  </p>
                  <v-divider></v-divider>
                  <v-divider></v-divider>
                  <template v-for="totalActiveUserCountry in sortActiveUsers">
                    <p :Key="totalActiveUserCountry.id" class="title">
                      <span>{{totalActiveUserCountry.country}}:</span>
                      <span class="display-1 font-weight-bold pl-1">{{totalActiveUserCountry.activeUsers}}</span>
                    </p>
                  </template>
                </v-card-text>
              </v-card>
            </v-hover>
          </v-col> -->
          <!--Banned users last 24h-->
          <!-- <v-col md="6">
            <v-hover>
              <v-card outlined height="100%" elevation="6" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 0}`" class="ma-0 pa-0" color="red lighten-3">
                <v-card-text class="ma-0 pa-0 pa-2">
                  <p class="title text-center">
                    <span>Total banned users last 24h</span>
                    <span class="display-1 font-weight-bold pl-1">({{item.totalBannedUsersDay}})</span>
                  </p>
                  <v-divider></v-divider>
                  <v-divider></v-divider>
                  <template v-for="totalBannedUserCountry in sortBannedUsers">
                    <p :Key="totalBannedUserCountry.id" class="title">
                      <span>{{totalBannedUserCountry.country}}:</span>
                      <span class="display-1 font-weight-bold pl-1">{{totalBannedUserCountry.bannedUser}}</span>
                    </p>
                  </template>
                </v-card-text>
              </v-card>
            </v-hover>
          </v-col> -->
        </v-row>
      </v-card-text>
      more?
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  components:{

  },
  data(){
    return{
      // Define the dialog v-model that we are using
      statisticUserCardDialog:false,
      // item: {},
    }
  },
  computed:{
    // Sort the users from most users to fewest
    // sortUsers(){
    //   return this.item.totalUsersData.slice().sort(function(a, b){
    //     return (a.users < b.users) ? 1 : -1;
    //   });
    // },
    // Sort through the total NEW users, and display the country with the most new users first
    // sortNewUsers(){
    //   return this.item.totalNewUsersDayData.slice().sort(function(a, b){
    //     return (a.newUsers < b.newUsers) ? 1 : -1;
    //   });
    // },
    // Sort through the Active users and display the country with the most active users first
    // sortActiveUsers(){
    //   return this.item.totalActiveUsersDayData.slice().sort(function(a, b) {
    //     return (a.activeUsers < b.activeUsers) ? 1 : -1;
    //   })
    // },
    // Sort through the Banned users and display the country with the most banned users first
    // sortBannedUsers(){
    //   return this.item.totalBannedUsersDayData.slice().sort(function(a,b) {
    //     return (a.bannedUser < b.bannedUser) ? 1 : -1;
    //   })
    // }
  },
  methods: {
    // Opening the dialog through the ref
    openDialog() {
      // this.item = item;
      this.statisticUserCardDialog = true;
    },
    // Close the dialog
    closeDialog() {
      this.statisticUserCardDialog = false;
    }
  }
}
</script>